"use strict";

import { participantConstants } from "../_constants";

export const participantGetApplicationRequest = (payload) => {
     return {
          type: participantConstants.PARTICIPANT_GET_APPLICATION_REQUEST,
          payload,
     };
};

export const participantGetApplicationComplete = (payload) => {
     return {
          type: participantConstants.PARTICIPANT_GET_APPLICATION_COMPLETE,
          payload,
     };
};

export const participantGetParticipantSummaryRequest = (payload) => {
     return {
          type: participantConstants.PARTICIPANT_GET_PARTICIPANT_SUMMARY_REQUEST,
          payload,
     };
};

export const participantGetParticipantSummaryComplete = (payload) => {
     return {
          type: participantConstants.PARTICIPANT_GET_PARTICIPANT_SUMMARY_COMPLETE,
          payload,
     };
};

export const participantGetAreasRequest = (payload) => {
     return {
          type: participantConstants.PARTICIPANT_GET_AREAS_REQUEST,
          payload,
     };
};

export const participantGetAreasComplete = (payload) => {
     return {
          type: participantConstants.PARTICIPANT_GET_AREAS_COMPLETE,
          payload,
     };
};

export const participantGetDealersRequest = (payload) => {
     return {
          type: participantConstants.PARTICIPANT_GET_DEALERS_REQUEST,
          payload,
     };
};

export const participantGetDealersComplete = (payload) => {
     return {
          type: participantConstants.PARTICIPANT_GET_DEALERS_COMPLETE,
          payload,
     };
};

export const participantGetRolesRequest = (payload) => {
     return {
          type: participantConstants.PARTICIPANT_GET_JOB_ROLES_REQUEST,
          payload,
     };
};

export const participantGetRolesComplete = (payload) => {
     return {
          type: participantConstants.PARTICIPANT_GET_JOB_ROLES_COMPLETE,
          payload,
     };
};

export const participantSaveNewParticipantRequest = (payload) => {
     return {
          type: participantConstants.PARTICIPANT_SAVE_NEW_PARTICIPANT_REQUEST,
          payload,
     };
};

export const participantSaveNewParticipantComplete = (payload) => {
     return {
          type: participantConstants.PARTICIPANT_SAVE_NEW_PARTICIPANT_COMPLETE,
          payload,
     };
};

export const participantUpdateParticipantStatusRequest = (payload) => {
     return {
          type: participantConstants.PARTICIPANT_UPDATE_PARTICIPANT_STATUS_REQUEST,
          payload,
     };
};

export const participantUpdateParticipantStatusComplete = (payload) => {
     return {
          type: participantConstants.PARTICIPANT_UPDATE_PARTICIPANT_STATUS_COMPLETE,
          payload,
     };
};

export const participantDeleteParticipantRequest = (payload) => {
     return {
          type: participantConstants.PARTICIPANT_DELETE_REQUEST,
          payload,
     };
};

export const participantDeleteParticipantComplete = (payload) => {
     return {
          type: participantConstants.PARTICIPANT_DELETE_COMPLETE,
          payload,
     };
};

export const participantActiveParticipantRequest = (payload) => {
     return {
          type: participantConstants.PARTICIPANT_SEND_PARTICIPANT_ACTIVATION_REQUEST,
          payload,
     };
};

export const participantActiveParticipantComplete = () => {
     return {
          type: participantConstants.PARTICIPANT_SEND_PARTICIPANT_ACTIVATION_COMPLETE,
     };
};

export const participantUpdateDealerRequest = (payload) => {
     return {
          type: participantConstants.PARTICIPANT_SEND_PARTICIPANT_UPDATE_DEALER_SHIP_REQUEST,
          payload,
     };
};

export const participantUpdateDealerComplete = (payload) => {
     return {
          type: participantConstants.PARTICIPANT_SEND_PARTICIPANT_UPDATE_DEALER_SHIP_COMPLETE,
          payload,
     };
};

export const participantUpdateJobRoleRequest = (payload) => {
     return {
          type: participantConstants.PARTICIPANT_SEND_PARTICIPANT_UPDATE_PARTICIPANT_JOB_ROLE_REQUEST,
          payload,
     };
};

export const participantUpdateJobRoleComplete = (payload) => {
     return {
          type: participantConstants.PARTICIPANT_SEND_PARTICIPANT_UPDATE_PARTICIPANT_JOB_ROLE_COMPLETE,
          payload,
     };
};

export const participantGetTlcCustomersRequest = (payload) => {
    return {
        type: participantConstants.PARTICIPANT_GET_TLC_CUSTOMERS_REQUEST,
        payload,
    };
};

export const participantGetTlcCustomersComplete = (payload) => {
    return {
        type: participantConstants.PARTICIPANT_GET_TLC_CUSTOMERS_COMPLETE,
        payload,
    };
};


export const participantGetCampaignMeasurementRequest = (payload) => {
    return {
        type: participantConstants.PARTICIPANT_GET_CAMPAIGN_MEASUREMENT_REQUEST,
        payload,
    };
};

export const participantGetCampaignMeasurementComplete = (payload) => {
    return {
        type: participantConstants.PARTICIPANT_GET_CAMPAIGN_MEASUREMENT_COMPLETE,
        payload,
    };
};